import { StreamingPlayerTypography } from '@heardis/stream-contracts';
import Tracklist from '../PageLayout/SidePanel/Tracklist/Tracklist';
import InfoContainer from './InfoContainer';
import classes from './TracklistContainer.module.css';

type TracklistContainerProps = {
  backgroundColor: string;
  typography: StreamingPlayerTypography;
  notesEnabled: boolean;
  spotifyEnabled: boolean;
  hideInfoContainer: () => void;
};

function TracklistContainer({ backgroundColor, typography, notesEnabled, spotifyEnabled, hideInfoContainer }: TracklistContainerProps) {
  return (
    <InfoContainer hideInfoContainer={hideInfoContainer} backgroundColor={backgroundColor} typography={typography}>
      <div>
        <h2 className={classes.tracklistContainerTitle}>
          Tracklist
        </h2>
        <Tracklist notesEnabled={notesEnabled} spotifyEnabled={spotifyEnabled} />
      </div>
    </InfoContainer>
  );
}

export default TracklistContainer;
